import { Database } from '@nozbe/watermelondb'

import { ComponentMessageVO } from '@repo/types'
import { Chat, Message } from '../model'
import { findMessageByMessageId } from '../readers'

const createMessage = async (chat: Chat, payload: ComponentMessageVO, database: Database) => {
  const messages = database.collections.get<Message>('messages')
  await database.write(
    async () => await messages.create((message: Message) => message.setMessageByComponentMessageVO(payload, chat))
  )
}

export const addMessage = async (chat: Chat, payload: ComponentMessageVO, database: Database) => {
  await database.write(async writer => {
    try {
      const message = await writer.callReader(async () => await findMessageByMessageId(payload.messageId, database))
      if (!message) {
        await writer.callWriter(async () => await createMessage(chat, payload, database))
      } else {
        await writer.callWriter(async () => await message.updateMessage(payload))
      }
    } catch (e) {
      console.error(e)
    }
  })
}
